import * as R from 'ramda';
import React, { Component, PropTypes } from 'react';
import {
  Dialog,
  Checkbox,
  RadioButton,
  FontIcon,
  FlatButton,
  CircularProgress,
  TextField,
} from 'material-ui';
import { connect } from 'react-redux';


class RequestDL extends Component {
  constructor() {
    super();
    this.state = {
      iagree: false,
    };
  }
  onCheckAgree = (_, checked) => this.setState({ iagree: checked });
  onCheck = setting => () => this.props.checkSetting(setting);
  onCheckPriority = priority => () => this.props.checkPriority(priority);
  onMsgChange = e => this.props.enterMsg(e.target.value);
  render() {
    const {
      open,
      priority,
      rateConversionSetting,
      closeDialog,
      files,
      loading,
      success,
      doRequestDL,
      messageForDL,
    } = this.props;
    const disableSubmit = !this.state.iagree || !rateConversionSetting || loading;
    const submitIcon = loading ? (
      <CircularProgress size={25} tickness={2} />
    ) : undefined;
    return (
      <Dialog
        open={open}
        title={<div style={{ backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '16px 2%' }} >
          Submit this workspace for data loading
        </div>}
        bodyStyle={{ padding: '32px' }}
        onRequestClose={closeDialog}
        autoScrollBodyContent
        actions={success ? <FlatButton
          label="dismiss"
          secondary
          onClick={closeDialog}
        /> : [
          <FlatButton
            key="cancel"
            label="cancel"
            primary
            onClick={closeDialog}
          />,
          <FlatButton
            key="submit"
            label="submit"
            disabled={disableSubmit}
            secondary
            onClick={doRequestDL}
            icon={submitIcon}
          />,
        ]}
      >
        {
          (() => {
            if (success) {
              return (
                <div>
                  <div style={{ margin: '1em 0', textAlign: 'center' }}>
                    <div>We have sent your request to our Data Loading team!</div>
                    <br/>
                    <br/>
                    <img src={require('../../../../../../www/images/ezload.png')} width={80}/>
                  </div>
                </div>
              );
            }
            if (!(files && files.length)) {
              return (
                <div>
                  We didn't find any files in this contract, please upload the files you received from the supplier.
                </div>
              );
            }
            return (
              <div>
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <FontIcon
                    className="tc-icon-warning2"
                    color="#ff4081"
                  />&nbsp;&nbsp;
                  <div className="flex-center">
                    TourConnect's data conversion wait times are approximately 2-4 weeks. If you need this contract urgently, we would recommend to cancel this request and manually convert these rates yourself.
                  </div>
                </div>
                <div style={{ margin: '2em 0' }}>
                  <div className="flex-tc-sb" style={{ width: '450px' }}>
                    <RadioButton
                      label="Convert & Require Supplier Signature"
                      checked={rateConversionSetting === 'opt-in'}
                      onCheck={this.onCheck('opt-in')}
                    />
                    <div
                      aria-label="TourConnect will convert all rates received into the TourConnect format, then require the supplier to review, sign, and submit the rates to you. NOTE: You will always have access to the original rates submitted."
                      className="hint--bottom hint--large"
                    >
                      <FontIcon
                        className="tc-icon-help_outline"
                      />
                    </div>
                  </div>
                  <div className="flex-tc-sb" style={{ width: '450px', marginBottom: '24px' }}>
                    <RadioButton
                      label="Convert & Do Not Require Supplier Signature"
                      checked={rateConversionSetting === 'opt-out'}
                      onCheck={this.onCheck('opt-out')}
                    />
                    <div
                      aria-label="TourConnect will convert all rates received into the TourConnect format, and you will be notified when this is complete. The supplier will not be required to review, sign, and submit the converted rates to you. NOTE: You will always have access to the original rates submitted."
                      className="hint--bottom hint--large"
                    >
                      <FontIcon
                        className="tc-icon-help_outline"
                      />
                    </div>
                  </div>
                  <label>What is the priority of this request?</label>
                  <div style={{ marginBottom: '24px' }}>
                    {
                      ['Highest', 'High', 'Medium', 'Low', 'Lowest'].map(str => (
                        <RadioButton
                          key={str}
                          label={str}
                          checked={priority === str}
                          onCheck={this.onCheckPriority(str)}
                        />
                      ))
                    }
                  </div>
                  <label>Optional Note/Instructions</label>
                  <div
                    style={{
                      padding: '8px 12px',
                      overflow: 'auto',
                      minHeight: '80px',
                      border: '1px solid #00BCD4',
                      margin: '12px 0',
                    }}
                  >
                    <FontIcon className="tc-icon-email" color="#bfbfbf" style={{ top: '12px' }} />
                    <TextField
                      id="commentBoxTextField"
                      hintStyle={{ fontSize: '14px' }}
                      underlineShow={false}
                      defaultValue={messageForDL}
                      onChange={this.onMsgChange}
                      style={{ float: 'right', width: '85%', marginRight: '5%' }}
                      multiLine
                      rowsMax={5}
                    />
                  </div>
                </div>
                <Checkbox
                  label="I understand that TourConnect is not responsible for any rates or rate-related data, including errors or omissions, whether submitted directly to you by the supplier or submitted via the TourConnect team after conversion to the TourConnect format."
                  checked={this.state.iagree}
                  onCheck={this.onCheckAgree}
                />
              </div>
            );
          })()
        }
      </Dialog>
    );
  }
}

RequestDL.propTypes = {
  open: PropTypes.bool,
  rateConversionSetting: PropTypes.string,
  priority: PropTypes.string,
  messageForDL: PropTypes.string,
  closeDialog: PropTypes.func,
  files: PropTypes.array,
  loading: PropTypes.bool,
  success: PropTypes.bool,
  doRequestDL: PropTypes.func,
  checkSetting: PropTypes.func,
  enterMsg: PropTypes.func,
  checkPriority: PropTypes.func,
};

const mapState = ({ contracting }) => {
  const defaultFiles = contracting.contractActivitiesProducts.getIn(
    ['rightSideContent', 'files'],
  );
  return {
    ...contracting.requestDL,
    files:  (defaultFiles && defaultFiles.toJS()) || R.path(['requestDL', 'files'], contracting),
  };
}

const mapAction = ({
  closeDialog: () => ({ type: 'CLOSE_REQUEST_RATE_LOADING_DIALOG' }),
  checkSetting: setting => ({ type: 'CHECK_RATE_LOADING_SETTING', payload: { setting } }),
  enterMsg: str => ({ type: 'ENTER_MESSAGE_FOR_DL_IN_REQUEST_DIALOG', payload: str }),
  checkPriority: priority => ({ type: 'CHECK_RATE_LOADING_PRIORITY', payload: { priority } }),
  doRequestDL: () => ({ type: 'REQUEST_DL' }),
});

export default connect(mapState, mapAction)(RequestDL);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/dialogs/request-data-loading.jsx